// src/components/store/sections/faqs/FaqV7BubbleqaOceanCyan.tsx
"use client";

import React from "react";
import DynamicFaqVariant from "./DynamicFaqVariant";

export default function FaqV7BubbleqaOceanCyan(props: any) {
  return (
    <DynamicFaqVariant
      variantNumber={7}
      archKey="bubble_qa"
      archLabel="Chat Bubble Q&A"
      palName="OceanCyan"
      grad="from-cyan-500 via-sky-500 to-blue-700"
      lightBg="bg-cyan-50"
      textCol="text-cyan-700"
      borderCol="border-cyan-200"
      btnCls="bg-blue-600 hover:bg-blue-700"
      hexCol="#06b6d4"
      {...props}
    />
  );
}
